define('plugins/musicfavourite/nls/artist/dialog',{
    'en-gb': {
        'upsell': {
            'heading': 'Keep up with your favourite artists',
            'text': 'Add this artist to get updates when they do something new and recommendations for similar music.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this artist'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'cy-gb': { //WELSH
        'upsell': {
            'heading': 'Keep up with your favourite artists',
            'text': 'Add this artist to get updates when they do something new and recommendations for similar music.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this artist'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'ga-gb': { //IRISH
        'upsell': {
            'heading': 'Keep up with your favourite artists',
            'text': 'Add this artist to get updates when they do something new and recommendations for similar music.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this artist'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'gd-gb': { //SCOTTISH
        'upsell': {
            'heading': 'Keep up with your favourite artists',
            'text': 'Add this artist to get updates when they do something new and recommendations for similar music.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this artist'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    }
});

